import RolesHelper from '@/helpers/roleHelper';
import CreateExpenseCard from '@/views/finance/expenses/deals/CreateExpenseCard';

const Crm = () => import(/*webpackChunkName: "group-crm" */ '@/views/crm/Crm.vue');
const Contacts = () => {
    if (!isMobile()) {
        return import(/*webpackChunkName: "group-crm" */'@/views/crm/contacts/Grid.vue');
    } else {
        return import(/*webpackChunkName: "group-crm" */'@/views/crm/contacts/ListMobile.vue');
    }
};
const ContactCard = () => {
    if (!isMobile()) {
        return import(/*webpackChunkName: "group-crm" */'@/views/crm/contacts/Card.vue');
    } else {
        return import(/*webpackChunkName: "group-crm" */'@/views/crm/contacts/CardMobile.vue');
    }
};
const ContactCardEdit = () => {
    if (!isMobile()) {
        return import(/*webpackChunkName: "group-crm" */'@/views/crm/contacts/CardEdit.vue');
    } else {
        return import(/*webpackChunkName: "group-crm" */'@/views/crm/contacts/CardEditMobile.vue');
    }
};
const Companies = () => import(/*webpackChunkName: "group-crm" */ '@/views/crm/companies/Grid.vue');
const CompanyCard = () => import(/*webpackChunkName: "group-crm" */'@/views/crm/companies/Card.vue');
const CompanyCardEdit = () => import(/*webpackChunkName: "group-crm" */'@/views/crm/companies/CardEdit.vue');
const Deals = () => {
    if (!isMobile()) {
        return import(/*webpackChunkName: "group-crm" */'@/views/crm/deals/Grid.vue');
    } else {
        return import(/*webpackChunkName: "group-crm" */'@/views/crm/deals/ListMobile.vue');
    }
};
const DealCard = () => {
    if (!isMobile()) {
        return import(/*webpackChunkName: "group-crm" */'@/views/crm/deals/Card.vue');
    } else {
        return import(/*webpackChunkName: "group-crm" */'@/views/crm/deals/CardMobile.vue');
    }
};
const View404 = () => {
    if (!isMobile()) {
        return import('@/views/404.vue');
    } else {
        return import('@/views/404-Mobile.vue');
    }
};

const SearchDeal = () => import(/*webpackChunkName: "group-crm" */ '@/views/search/deal/Grid.vue');
const SearchLead = () => import(/*webpackChunkName: "group-crm" */ '@/views/search/lead/Grid.vue');
const SearchContact = () => import(/*webpackChunkName: "group-crm" */ '@/views/search/contact/Grid.vue');

const Leads = () => import(/*webpackChunkName: "group-crm" */ '@/views/crm/leads/Grid.vue');
const LeadCard = () => import(/*webpackChunkName: "group-crm" */'@/views/crm/leads/Card.vue');
const LeadCardEdit = () => import(/*webpackChunkName: "group-crm" */'@/views/crm/leads/CardEdit.vue');

const Finance = () => import(/*webpackChunkName: "group-finance" */ '@/views/finance/Finance.vue');
const Cash = () => import(/*webpackChunkName: "group-finance" */ '@/views/finance/cash/List.vue');
const DebtsEmployers = () => import(/*webpackChunkName: "group-finance" */ '@/views/finance/debts/Employers.vue');
const DebtsContacts = () => import(/*webpackChunkName: "group-finance" */ '@/views/finance/debts/Contacts.vue');
const DebtsDelivery = () => import(/*webpackChunkName: "group-finance" */ '@/views/finance/debts/Delivery.vue');
const IncomesBase = () => import(/*webpackChunkName: "group-finance" */ '@/views/finance/incomes/BaseGrid.vue');
const IncomesCash = () => import(/*webpackChunkName: "group-finance" */ '@/views/finance/incomes/CashGrid.vue');
const IncomesCashLess = () => import(/*webpackChunkName: "group-finance" */ '@/views/finance/incomes/CashLessGrid.vue');
const IncomeCashCard = () => import(/*webpackChunkName: "group-finance" */ '@/views/finance/incomes/CashCard.vue');
const IncomeCashLessCard = () => import(/*webpackChunkName: "group-finance" */ '@/views/finance/incomes/CashLessCard.vue');

const ExpensesDeal = () => import(/*webpackChunkName: "expenses" */ '@/views/finance/expenses/deals/BaseGrid.vue');
const ExpensesRegular = () => import(/*webpackChunkName: "expenses" */ '@/views/finance/expenses/regular/BaseGrid.vue');
const ExpensesProduction = () => import(/*webpackChunkName: "expenses" */ '@/views/finance/expenses/production/BaseGrid.vue');
const ExpensesRegistryEmployers = () => import(/*webpackChunkName: "expenses" */ '@/views/finance/expenses/registry-employers/BaseGrid.vue');
const ExpensesProductionCard = () => import(/*webpackChunkName: "expenses" */ '@/views/finance/expenses/production/ProductionExpensesCard.vue');

const SalaryPayroll = () => import(/*webpackChunkName: "group-finance" */ '@/views/finance/salary/Payroll.vue');
const SalaryPayrollInfo = () => import(/*webpackChunkName: "group-finance" */ '@/views/finance/salary/PayrollInfo.vue');
const SalaryPayrollInfoForEmployer = () => import(/*webpackChunkName: "group-finance" */ '@/views/finance/salary/PayrollInfoEmployer.vue');
const SalaryPrepayment = () => import(/*webpackChunkName: "group-finance" */ '@/views/finance/salary/Prepayment.vue');

const Login = () => import('@/views/Login.vue');

const Employers = () => import('@/views/employers/Grid.vue');

const EmployerCard = () => import('@/views/employers/Card.vue');
const EmployerCardEdit = () => import('@/views/employers/CardEdit.vue');

const MeasurementMap = () => import('@/views/measurement-map/MeasurementMap.vue');
const InstallationMap = () => import('@/views/installation-map/InstallationMap.vue');

const SystemLog = () => import('@/views/logs/SystemLog.vue');
const LeadsLog = () => import('@/views/logs/LeadsLog.vue');
const SmsLog = () => import('@/views/logs/SmsLog.vue');

const Settings = () => import('@/views/settings/Settings.vue');

const Tasks = () => {
    if (!isMobile()) {
        return import('@/views/tasks/Grid.vue');
    } else {
        return import('@/views/tasks/ListMobile.vue');
    }
};
const TaskCard = () => {
    if (!isMobile()) {
        return import('@/views/tasks/Card.vue');
    } else {
        return import('@/views/tasks/CardMobile.vue');
    }
};
const TaskCardEdit = () => {
    if (!isMobile()) {
        return import('@/views/tasks/CardEdit.vue');
    } else {
        return import('@/views/tasks/CardEditMobile.vue');
    }
};

const TimesheetGrid = () => import('@/views/timesheet/Grid.vue');
const CalendarGrid = () => import('@/views/calendar/Grid.vue');
const AnalyticsEmployersRating = () => import('@/views/analytics/employers/rating/Rating.vue');
const AnalyticsEmployersPlan = () => import('@/views/analytics/employers/plan/Plan.vue');
const AnalyticsDealsProfit = () => import('@/views/analytics/deal/DealProfit.vue');
const RatingDealsGrid = () => import('@/views/analytics/employers/rating/RatingDealsGrid.vue');
const RatingLeadsGrid = () => import('@/views/analytics/employers/rating/RatingLeadsGrid.vue');
const ReferencesContractorsGrid = () => import('@/views/references/contractors/Grid.vue');
const ContractorCardEdit = () => import(/*webpackChunkName: "group-crm" */'@/views/references/contractors/CardEdit.vue');

const routes = [
    { path: '/crm/leads/deal:id', redirect: '/crm/deal/:id' },
    { path: '/crm/leads/lead:id', redirect: '/crm/leads/:id' },
    { path: '/login', name: 'login', component: Login, meta: { layout: 'Start' } },
    {
        path: '/tasks',
        name: 'tasks',
        component: Tasks,
        meta: {
            roles: [
                RolesHelper.task_by_employer,
                RolesHelper.task_by_office,
                RolesHelper.task_full_access
            ]
        }
    },
    {
        path: '/tasks/all',
        name: 'tasks-all',
        component: Tasks,
        meta: {
            filterAlias: 'all',
            roles: [
                RolesHelper.task_by_employer,
                RolesHelper.task_by_office,
                RolesHelper.task_full_access
            ]
        }
    },
    {
        path: '/tasks/overdue',
        name: 'tasks-overdue',
        component: Tasks,
        meta: {
            filterAlias: 'overdue',
            roles: [
                RolesHelper.task_by_employer,
                RolesHelper.task_by_office,
                RolesHelper.task_full_access
            ]
        }
    },
    {
        path: '/tasks/today',
        name: 'tasks-today',
        component: Tasks,
        meta: {
            filterAlias: 'today',
            roles: [
                RolesHelper.task_by_employer,
                RolesHelper.task_by_office,
                RolesHelper.task_full_access
            ]
        }
    },
    {
        path: '/tasks/tomorrow',
        name: 'tasks-tomorrow',
        component: Tasks,
        meta: {
            filterAlias: 'tomorrow',
            roles: [
                RolesHelper.task_by_employer,
                RolesHelper.task_by_office,
                RolesHelper.task_full_access
            ]
        }
    },
    {
        path: '/tasks/timeless',
        name: 'tasks-timeless',
        component: Tasks,
        meta: {
            filterAlias: 'timeless',
            roles: [
                RolesHelper.task_by_employer,
                RolesHelper.task_by_office,
                RolesHelper.task_full_access
            ]
        }
    },
    {
        path: '/tasks/new',
        name: 'task-card-new',
        props: true,
        component: TaskCardEdit,
        meta: {
            roles: [
                RolesHelper.task_by_employer,
                RolesHelper.task_by_office,
                RolesHelper.task_full_access
            ]
        }
    },
    {
        path: '/tasks/:id',
        name: 'task-card',
        props: true,
        component: TaskCard,
        meta: {
            roles: [
                RolesHelper.task_by_employer,
                RolesHelper.task_by_office,
                RolesHelper.task_full_access
            ]
        }
    },
    {
        path: '/tasks/:id/edit',
        name: 'task-card-edit',
        props: true,
        component: TaskCardEdit,
        meta: {
            roles: [
                RolesHelper.task_by_employer,
                RolesHelper.task_by_office,
                RolesHelper.task_full_access
            ]
        }
    },
    { path: '/crm', name: 'crm', component: Crm },
    {
        path: '/crm/contacts',
        name: 'contacts',
        component: Contacts,
        meta: {
            roles: [
                RolesHelper.companies_by_employer,
                RolesHelper.companies_by_office,
                RolesHelper.companies_read,
                RolesHelper.companies_full_access
            ]
        }
    },
    {
        path: '/crm/contacts/new',
        name: 'contact-card-new',
        component: ContactCardEdit,
        meta: {
            roles: [
                RolesHelper.companies_by_employer,
                RolesHelper.companies_by_office,
                RolesHelper.companies_read,
                RolesHelper.companies_full_access
            ]
        }
    },
    {
        path: '/crm/contacts/:id',
        name: 'contact-card',
        props: true,
        component: ContactCard,
        meta: {
            roles: [
                RolesHelper.companies_by_employer,
                RolesHelper.companies_by_office,
                RolesHelper.companies_read,
                RolesHelper.companies_full_access
            ]
        }
    },
    {
        path: '/crm/contacts/:id/edit',
        name: 'contact-card-edit',
        props: true,
        component: ContactCardEdit,
        meta: {
            roles: [
                RolesHelper.companies_by_employer,
                RolesHelper.companies_by_office,
                RolesHelper.companies_read,
                RolesHelper.companies_full_access
            ]
        }
    },
    {
        path: '/crm/leads',
        name: 'leads',
        component: Leads,
        meta: {
            roles: [
                RolesHelper.lead_by_office,
                RolesHelper.lead_full_access,
                RolesHelper.lead_responsible
            ]
        }
    },
    {
        path: '/crm/leads/new',
        name: 'lead-card-new',
        component: LeadCardEdit,
        meta: {
            roles: [
                RolesHelper.lead_by_office,
                RolesHelper.lead_full_access,
                RolesHelper.lead_responsible
            ]
        }
    },
    {
        path: '/crm/leads/:id/view',
        name: 'lead-card-view',
        props: true,
        component: LeadCard,
        meta: {
            roles: [
                RolesHelper.lead_by_office,
                RolesHelper.lead_full_access,
                RolesHelper.lead_responsible
            ]
        }
    },
    {
        path: '/crm/leads/:id',
        name: 'lead-card',
        props: true,
        component: LeadCardEdit,
        meta: {
            roles: [
                RolesHelper.lead_by_office,
                RolesHelper.lead_full_access,
                RolesHelper.lead_responsible
            ]
        }
    },
    {
        path: '/crm/deals',
        name: 'deals',
        component: Deals,
        meta: {
            roles: [
                RolesHelper.deal_ceo,
                RolesHelper.deal_chief_technologist,
                RolesHelper.deal_financial_director,
                RolesHelper.deal_head_installation,
                RolesHelper.deal_head_service,
                RolesHelper.deal_installer,
                RolesHelper.deal_manager,
                RolesHelper.deal_measurer,
                RolesHelper.deal_office_manager
            ]
        }
    },
    {
        path: '/search/deal/:query/',
        name: 'search-deal-list',
        props: true,
        component: SearchDeal,
        meta: {}
    },
    {
        path: '/search/lead/:query/',
        name: 'search-lead-list',
        props: true,
        component: SearchLead,
        meta: {}
    },
    {
        path: '/search/contact/:query/',
        name: 'search-contact-list',
        props: true,
        component: SearchContact,
        meta: {}
    },
    {
        path: '/crm/deal/new',
        name: 'deal-card-new',
        component: DealCard,
        meta: {
            editMode: true,
            roles: [
                RolesHelper.deal_ceo,
                RolesHelper.deal_chief_technologist,
                RolesHelper.deal_financial_director,
                RolesHelper.deal_head_installation,
                RolesHelper.deal_head_service,
                RolesHelper.deal_installer,
                RolesHelper.deal_manager,
                RolesHelper.deal_measurer,
                RolesHelper.deal_office_manager
            ]
        }
    },
    {
        path: '/crm/deal/:id',
        name: 'deal-card',
        props: true,
        component: DealCard,
        meta: {
            editMode: true,
            roles: [
                RolesHelper.deal_ceo,
                RolesHelper.deal_chief_technologist,
                RolesHelper.deal_financial_director,
                RolesHelper.deal_head_installation,
                RolesHelper.deal_head_service,
                RolesHelper.deal_installer,
                RolesHelper.deal_manager,
                RolesHelper.deal_measurer,
                RolesHelper.deal_office_manager
            ]
        }
    },
    {
        path: '/crm/deal/:id/view',
        name: 'deal-card-view',
        props: true,
        component: DealCard,
        meta: {
            editMode: false,
            roles: [
                RolesHelper.deal_ceo,
                RolesHelper.deal_chief_technologist,
                RolesHelper.deal_financial_director,
                RolesHelper.deal_head_installation,
                RolesHelper.deal_head_service,
                RolesHelper.deal_installer,
                RolesHelper.deal_manager,
                RolesHelper.deal_measurer,
                RolesHelper.deal_office_manager
            ]
        }
    },
    {
        path: '/finance',
        name: 'finance',
        component: Finance,
        meta: {
            roles: [
                RolesHelper.operation_cashless,
                RolesHelper.operation_employer,
                RolesHelper.operation_full_access,
                RolesHelper.operation_full_access_except_expense_confirm,
                RolesHelper.operation_office_accountant
            ]
        }
    },
    {
        path: '/finance/cash',
        name: 'cash',
        component: Cash,
        meta: {
            roles: [
                RolesHelper.cash_chief_accountant,
                RolesHelper.cash_director,
                RolesHelper.cash_office_accountant
            ]
        }
    },
    {
        path: '/finance/debts/employers',
        name: 'debts-employers',
        component: DebtsEmployers,
        meta: {
            roles: [
                RolesHelper.debt_all
            ]
        }
    },
    {
        path: '/finance/debts/contacts',
        name: 'debts-contacts',
        component: DebtsContacts,
        meta: {
            roles: [
                RolesHelper.debt_all
            ]
        }
    },
    {
        path: '/finance/debts/delivery',
        name: 'debts-delivery',
        component: DebtsDelivery,
        meta: {
            roles: [
                RolesHelper.debt_all
            ]
        }
    },
    {
        path: '/finance/salary/payroll',
        name: 'salary-payroll',
        component: SalaryPayroll,
        meta: {
            roles: [
                RolesHelper.expenses_all
            ]
        }
    },
    {
        path: '/finance/salary/payroll-info',
        name: 'salary-payroll-info',
        component: SalaryPayrollInfo,
        meta: {
            roles: [
                RolesHelper.expenses_all
            ]
        }
    },
    {
        path: '/finance/salary/payroll-info/employer/:employer_id/:report_date',
        name: 'salary-payroll-info-employer',
        component: SalaryPayrollInfoForEmployer,
        meta: {
            roles: [
                RolesHelper.expenses_all
            ]
        }
    },
    {
        path: '/finance/salary/prepayment',
        name: 'salary-prepayment',
        component: SalaryPrepayment,
        meta: {
            roles: [
                RolesHelper.expenses_all
            ]
        }
    },
    {
        path: '/finance/incomes/all',
        name: 'incomes-all',
        component: IncomesBase,
        meta: {
            roles: [
                RolesHelper.incomes_all,
                RolesHelper.incomes_employer
            ]
        }
    },
    {
        path: '/finance/expenses/deals',
        name: 'expenses-deals',
        component: ExpensesDeal,
        meta: {
            roles: [
                RolesHelper.expenses_all
            ]
        }
    },
    {
        path: '/finance/expenses/regular',
        name: 'expenses-regular',
        component: ExpensesRegular,
        meta: {
            roles: [
                RolesHelper.expenses_all
            ]
        }
    },
    {
        path: '/finance/expenses/production',
        name: 'expenses-production',
        component: ExpensesProduction,
        meta: {
            roles: [
                RolesHelper.expenses_all
            ]
        }
    },
    {
        path: '/finance/expenses/registry_employers',
        name: 'expenses-registry-employers',
        component: ExpensesRegistryEmployers,
        meta: {
            roles: [
                RolesHelper.expenses_registry_employers
            ]
        }
    },
    {
        path: '/finance/expenses/production/:id',
        name: 'production-expense-card',
        component: ExpensesProductionCard,
        props: true,
        meta: {
            editMode: true,
            roles: [
                RolesHelper.expenses_all
            ]
        }
    },
    {
        path: '/finance/expenses/deals/:id',
        name: 'create-expense-card',
        component: CreateExpenseCard,
        props: true,
        meta: {
            editMode: true,
            roles: [
                RolesHelper.expenses_all
            ]
        }
    },
    {
        path: '/finance/incomes/cash',
        name: 'incomes-cash',
        component: IncomesCash,
        meta: {
            roles: [
                RolesHelper.incomes_all,
                RolesHelper.incomes_employer
            ]
        }
    },
    {
        path: '/finance/incomes/cashless',
        name: 'incomes-cashless',
        component: IncomesCashLess,
        meta: {
            roles: [
                RolesHelper.incomes_all,
                RolesHelper.incomes_employer
            ]
        }
    },
    {
        path: '/finance/incomes/cash/:id',
        name: 'income-cash-card',
        component: IncomeCashCard,
        props: true,
        meta: {
            editMode: true,
            roles: [
                RolesHelper.incomes_cash_director,
                RolesHelper.incomes_cash_employer
            ]
        }
    },
    {
        path: '/finance/incomes/cash/:id/view',
        name: 'income-cash-card-view',
        component: IncomeCashCard,
        props: true,
        meta: {
            editMode: false,
            roles: [
                RolesHelper.incomes_cash_director,
                RolesHelper.incomes_cash_employer,
                RolesHelper.incomes_all,
                RolesHelper.incomes_employer
            ]
        }
    },
    {
        path: '/finance/incomes/cashless/:id',
        name: 'income-cashless-card',
        component: IncomeCashLessCard,
        props: true,
        meta: {
            editMode: true,
            roles: [
                RolesHelper.incomes_cashless_accountant,
                RolesHelper.incomes_cashless_employer
            ]
        }
    },
    {
        path: '/finance/incomes/cashless/:id/view',
        name: 'income-cashless-card-view',
        component: IncomeCashLessCard,
        props: true,
        meta: {
            editMode: false,
            roles: [
                RolesHelper.incomes_cashless_accountant,
                RolesHelper.incomes_cashless_employer,
                RolesHelper.incomes_all,
                RolesHelper.incomes_employer
            ]
        }
    },
    {
        path: '/measurement-map',
        name: 'measurement-map',
        component: MeasurementMap,
        meta: {
            roles: [
                RolesHelper.map_full_access,
                RolesHelper.map_view
            ]
        }
    },
    {
        path: '/installation-map',
        name: 'installation-map',
        component: InstallationMap,
        meta: {
            roles: [
                RolesHelper.installation_map_full_access,
                RolesHelper.installation_map_view
            ]
        }
    },
    {
        path: '/logs/system',
        name: 'system-log',
        component: SystemLog,
        meta: {
            roles: [
                RolesHelper.log_system_view
            ]
        }
    },
    {
        path: '/logs/leads',
        name: 'leads-log',
        component: LeadsLog,
        meta: {
            roles: [
                RolesHelper.log_lead_view
            ]
        }
    },
    {
        path: '/logs/sms',
        name: 'sms-log',
        component: SmsLog,
        meta: {
            roles: [
                RolesHelper.log_sms_view
            ]
        }
    },
    { path: '/settings', name: 'settings', component: Settings },
    {
        path: '/employers',
        name: 'employers',
        component: Employers,
        meta: {
            roles: [
                RolesHelper.office_manager,
                RolesHelper.office_staff,
                RolesHelper.head_office,
                RolesHelper.all_staff
            ]
        }
    },
    {
        path: '/employers/new',
        name: 'employer-card-new',
        component: EmployerCardEdit,
        meta: {
            roles: [
                RolesHelper.office_manager,
                RolesHelper.head_office,
                RolesHelper.all_staff
            ]
        }
    },
    {
        path: '/employers/:id',
        name: 'employer-card',
        props: true,
        component: EmployerCard,
        meta: {
            roles: [
                RolesHelper.office_manager,
                RolesHelper.office_staff,
                RolesHelper.head_office,
                RolesHelper.all_staff
            ]
        }
    },
    {
        path: '/employers/:id/edit',
        name: 'employer-card-edit',
        props: true,
        component: EmployerCardEdit,
        meta: {
            roles: [
                RolesHelper.office_manager,
                RolesHelper.head_office,
                RolesHelper.all_staff
            ]
        }
    },
    {
        path: '/',
        name: 'home',
        redirect: {
            name: 'tasks-all'
        },
        meta: {
            roles: [
                RolesHelper.task_by_employer,
                RolesHelper.task_by_office,
                RolesHelper.task_full_access
            ]
        }
    },
    {
        path: '/timesheet',
        name: 'timesheet',
        component: TimesheetGrid,
        meta: {
            roles: [
                RolesHelper.timesheet_installers_all,
                RolesHelper.timesheet_installers_self,
                RolesHelper.timesheet_managers_all,
                RolesHelper.timesheet_managers_self,
                RolesHelper.timesheet_measurers_all,
                RolesHelper.timesheet_measurers_self
            ]
        }
    },
    {
        path: '/calendar',
        name: 'calendar',
        component: CalendarGrid,
        meta: {
            roles: [
                RolesHelper.calendar_full_access,
                RolesHelper.calendar_view
            ]
        }
    },
    {
        path: '/analytics/employers/rating',
        name: 'analytics-employers-rating',
        component: AnalyticsEmployersRating,
        meta: {
            roles: [
                RolesHelper.analytics_employers_rating
            ]
        }
    },
    {
        path: '/analytics/employers/plan',
        name: 'analytics-employers-plan',
        component: AnalyticsEmployersPlan,
        meta: {
            roles: [
                RolesHelper.analytics_employers_plan_full,
                RolesHelper.analytics_employers_plan_view
            ]
        }
    },
    {
        path: '/analytics/employers/rating/deals',
        name: 'analytics-employers-rating-deals',
        component: RatingDealsGrid,
        meta: {
            roles: [
                RolesHelper.deal_ceo,
                RolesHelper.deal_chief_technologist,
                RolesHelper.deal_financial_director,
                RolesHelper.deal_head_installation,
                RolesHelper.deal_head_service,
                RolesHelper.deal_installer,
                RolesHelper.deal_manager,
                RolesHelper.deal_measurer,
                RolesHelper.deal_office_manager
            ]
        }
    },
    {
        path: '/analytics/employers/rating/leads',
        name: 'analytics-employers-rating-leads',
        component: RatingLeadsGrid,
        meta: {
            roles: [
                RolesHelper.lead_by_office,
                RolesHelper.lead_full_access,
                RolesHelper.lead_responsible
            ]
        }
    },
    {
        path: '/analytics/deal/deal-profit',
        name: 'analytics-deal-profit',
        component: AnalyticsDealsProfit,
        meta: {
            roles: [
                RolesHelper.analytics_deal_profit
            ]
        }
    },
    {
        path: '/references/contractors',
        name: 'references-contractors',
        component: ReferencesContractorsGrid,
        meta: {
            roles: [
                RolesHelper.references_contractors
            ]
        }
    },
    {
        path: '/references/contractors/new',
        name: 'contractor-card-new',
        component: ContractorCardEdit,
        meta: {
            roles: [
                RolesHelper.references_contractors
            ]
        }
    },
    {
        path: '/references/contractors/:id/edit',
        name: 'contractor-card',
        props: true,
        component: ContractorCardEdit,
        meta: {
            roles: [
                RolesHelper.references_contractors
            ]
        }
    },
    { path: '/start-page', name: 'start-page', component: () => import('@/views/start-page'), meta: { system: true } },
    {
        path: '*',
        name: 'not-found',
        component: View404,
        meta: {
            system: true
        }
    },
    { path: '/forbidden', name: 'forbidden', component: () => import('@/views/403'), meta: { system: true } }
];

const isMobile = () => {
    const cookies = document.cookie.split('; ').reduce((prev, current) => {
        const [name, value] = current.split('=');
        prev[name] = value;
        return prev;
    }, {});

    return Object.prototype.hasOwnProperty.call(cookies, 'isMobile') && JSON.parse(cookies.isMobile) === true && document.documentElement.clientWidth < 1200;
};

export default routes;
